import { INewRouteApplication } from "@/domain/entities/bbs/newRouteApplication.types";

export class NewRouteApplication implements INewRouteApplication {
  readonly serviceUid: string;
  readonly parentUid: string;
  readonly memberUid: string;
  readonly memberName: string;
  readonly title: string;
  readonly displayYn: boolean;
  readonly receiverCount: number;
  readonly talkTypeCode: string;
  readonly talkTypeName: string;
  readonly uid: string;
  readonly statusCode: string;
  readonly statusName: string;
  readonly campusCode: string;
  readonly campusName: string;
  readonly workTimeCode: string;
  readonly workTimeName: string;
  readonly roadAddress: string;
  readonly dongAddress: string;
  readonly detailAddress: string;
  readonly useBeginDtm: string;
  readonly useEndDtm: string;
  readonly createdTs: string;
  readonly savedTs: string;

  constructor(data: INewRouteApplication) {
    this.serviceUid = data.serviceUid;
    this.parentUid = data.parentUid;
    this.memberUid = data.memberUid;
    this.memberName = data.memberName;
    this.title = data.title;
    this.displayYn = data.displayYn;
    this.receiverCount = data.receiverCount;
    this.talkTypeCode = data.talkTypeCode;
    this.talkTypeName = data.talkTypeName;
    this.uid = data.uid;
    this.statusCode = data.statusCode;
    this.statusName = data.statusName;
    this.campusCode = data.campusCode;
    this.campusName = data.campusName;
    this.workTimeCode = data.workTimeCode;
    this.workTimeName = data.workTimeName;
    this.roadAddress = data.roadAddress;
    this.dongAddress = data.dongAddress;
    this.detailAddress = data.detailAddress;
    this.useBeginDtm = data.useBeginDtm;
    this.useEndDtm = data.useEndDtm;
    this.createdTs = data.createdTs;
    this.savedTs = data.savedTs;
  }
}
